export const Logger = {
    log: (context: string, message: string, ...args: unknown[]) => {
        console.log(`[${context}] ${message}`, ...args);
    },
    error: (context: string, message: string, ...args: unknown[]) => {
        console.error(`[${context}] ${message}`, ...args);
    },
    warn: (context: string, message: string, ...args: unknown[]) => {
        console.warn(`[${context}] ${message}`, ...args);
    },
    info: (context: string, message: string, ...args: unknown[]) => {
        console.info(`[${context}] ${message}`, ...args);
    },
};
